/**
 * author:liangyu \
 * date:215-10-30
 */
'use strict';
angular
    .module('trsEditorAuthMoule', ['mgcrea.ngStrap.typeahead'])
    .config([
        '$typeaheadProvider',
        function($typeaheadProvider) {
            angular.extend($typeaheadProvider.defaults, {
                animation: 'am-fade',
                prefixClass: 'typeahead',
                prefixEvent: '$typeahead',
                placement: 'bottom-left',
                templateUrl: './editingCenter/directive/app/views/suggestion.html',
                trigger: 'focus',
                container: false,
                keyboard: true,
                html: false,
                delay: 0,
                minLength: 1,
                filter: 'bsAsyncFilter',
                limit: 30,
                autoSelect: false,
                comparator: '',
                trimValue: true,
            });
        },
    ])
    .directive('editorAuthDir', [
        '$timeout',
        '$typeahead',
        '$location',
        '$validation',
        '$q',
        'trsHttpService',
        'modalDialog',
        'localStorageService',
        '$sessionStorage',
        function($timeout, $typeahead, $location, $validationProvider, $q, trsHttpService, modalDialog, localStorageService, $sessionStorage) {
            return {
                restrict: 'AE',
                scope: {
                    tempAuthors: '=author',
                    isIconShow: '=formdisabled',
                    isSpecial: '=originalchildtype', // 是否是特约稿
                },
                templateUrl: './editingCenter/directive/app/views/editor_auth_tpl.html',

                /* scope: {
                 //editorJson: '=',
                 //authorForm: "="
             },*/
                link: function(scope, iElement, iAttrs) {
                    // 获得路径
                    scope.path = $location
                        .path()
                        .split('/')
                        .pop();
                    // 初始化
                    initStatus();
                    // 存储作者信息
                    scope.authEdit = function() {
                        if (scope.tempAuthors.length === 0) {
                            addAuthor();
                        } else {
                            $validationProvider.validate(scope.authorForm).success(function() {
                                addAuthor();
                            });
                        }

                        /**
                         * [addAuthor description]
                         *
                         * @return  {[type]}  [return description]
                         */
                        function addAuthor() {
                            scope.tempAuthor = {
                                ID: '0',
                                TYPE: '22',
                            };
                            scope.tempAuthors.push(scope.tempAuthor);
                            scope.currAuthor = scope.tempAuthor;
                            initSelectedBank();
                            scope.authorForm.$setPristine();
                        }
                    };
                    scope.authMessage = function(author) {
                        $validationProvider.validate(scope.authorForm).success(function() {
                            scope.currAuthor = author;
                            initSelectedBank();
                        });
                    };
                    scope.authDelete = function(record) {
                        scope.tempAuthors.splice(record, 1);
                        scope.currAuthor = scope.tempAuthors[scope.tempAuthors.length - 1];
                        initSelectedBank();
                    };

                    /**
                     * [initStatus description]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function initStatus() {
                        scope.bankOptions = [
                            {
                                name: '请选择开户银行',
                                value: 0,
                            },
                            {
                                name: '工商银行',
                                value: 1,
                            },
                            {
                                name: '农业银行',
                                value: 2,
                            },
                            {
                                name: '中国银行',
                                value: 3,
                            },
                            {
                                name: '建设银行',
                                value: 4,
                            },
                            {
                                name: '交通银行',
                                value: 5,
                            },
                            {
                                name: '上海浦东发展银行',
                                value: 6,
                            },
                            {
                                name: '兴业银行',
                                value: 7,
                            },
                            {
                                name: '光大银行',
                                value: 8,
                            },
                            {
                                name: '深圳发展银行',
                                value: 9,
                            },
                            {
                                name: '民生银行',
                                value: 10,
                            },
                            {
                                name: '中信银行',
                                value: 11,
                            },
                            {
                                name: '招商银行',
                                value: 12,
                            },
                            {
                                name: '广东发展银行',
                                value: 13,
                            },
                            {
                                name: '华夏银行',
                                value: 14,
                            },
                        ];
                        scope.status = {
                            // 从缓存中获取当前用户登录的组织ID
                            curGroupId: '',
                        };
                        scope.status.curGroupId =
                            // localStorageService.get('mlfCachedUser') === null || angular.isUndefined(localStorageService.get('mlfCachedUser')) // session改变
                            $sessionStorage.get('mlfCachedUser') === null || angular.isUndefined($sessionStorage.get('mlfCachedUser'))
                                ? ''
                                // : localStorageService.get('mlfCachedUser').GroupId; // session改变
                                : $sessionStorage.get('mlfCachedUser').GroupId;

                        scope.isvalid = false; // 表单默认状态
                        $timeout(function() {
                            if (scope.tempAuthors.length > 0) {
                                scope.currAuthor = scope.tempAuthors[0];
                            }
                            initSelectedBank();
                            if (scope.tempAuthors.length === 0 || !angular.isDefined(scope.tempAuthors[0].isCreate)) {
                                if (scope.tempAuthors.length > 0) {
                                    scope.currAuthor = scope.tempAuthors[0];
                                }
                                initSelectedBank();
                            } else {
                                getCurrentLoginUser().then(function(data) {
                                    scope.currAuthor = data[0];
                                    scope.currAuthor.MOBILEPHONE = scope.currAuthor.MOBILE;
                                    scope.currAuthor.TYPE = '23';
                                    scope.tempAuthors[0] = scope.currAuthor;
                                    initSelectedBank();
                                });
                            }
                        }, 500);
                        // scope.authorIndex = scope.authorJson.length - 1; //初始化显示用户下标
                        // 初始化检索提示服务开始
                        scope.searchParams = {
                            methodname: 'queryUsersByName',
                            serviceid: 'mlf_extuser',
                            IsSearchAll: true,
                            Name: '',
                        };
                        // 初始化检索提示服务结束
                        // 初始化表单是否禁用开始
                        // scope.disabled = (scope.authorJson[scope.authorIndex].TYPE == "23") ? true : false;
                        // 初始化表单是否禁用结束
                    }

                    /**
                     * [initSelectedBank description]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function initSelectedBank() {
                        scope.selectedBankOption = angular.copy(scope.bankOptions[0]);
                        if (!scope.currAuthor) {
                            return;
                        }
                        for (var i in scope.bankOptions) {
                            var item = scope.bankOptions[i];
                            if (item.name === scope.currAuthor.BANKACCOUNT) {
                                scope.selectedBankOption = angular.copy(scope.bankOptions[i]);
                                break;
                            }
                        }
                        scope.currAuthor.BANKACCOUNT = scope.selectedBankOption.value === 0 ? '' : scope.selectedBankOption.name;
                    }
                    var promise;
                    scope.getSuggestions = function(viewValue) {
                        if (promise) {
                            $timeout.cancel(promise);
                            promise = null;
                        }

                        promise = $timeout(function() {
                            if (viewValue !== '' && !angular.isObject(viewValue)) {
                                scope.searchParams.Name = viewValue;
                                if (angular.isDefined(scope.currAuthor.USERNAME)) {
                                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), scope.searchParams, 'post').then(function(data) {
                                        if (data.length != 0) {
                                            angular.forEach(data, function(data_, index, array) {
                                                data[index].PINYINNAME = scope.searchParams.Name;
                                            });
                                            data = data.filter((item) => item.TYPE !== '22');
                                        }
                                        return data;
                                    });
                                }
                            }
                        }, 10);

                        return promise;
                    };
                    scope.$watch('currAuthor.USERNAME', function(newValue, oldValue) {
                        if (angular.isObject(newValue)) {
                            var flag = true;
                            angular.forEach(scope.tempAuthors, function(data, index, array) {
                                if (data.ID == newValue.ID && data.TYPE == newValue.TYPE) {
                                    flag = false;
                                    modalDialog.alertType('', '请勿重复添加用户', 'warning', false);
                                }
                            });
                            if (flag) {
                                scope.tempAuthors[scope.tempAuthors.indexOf(scope.currAuthor)] = newValue;
                                scope.currAuthor = newValue;
                            } else {
                                scope.tempAuthors[scope.tempAuthors.indexOf(scope.currAuthor)].USERNAME = '';
                                scope.currAuthor.USERNAME = '';
                            }
                        }
                    });

                    /**
                     * [autoFillUnit description] 当所填人员为外部人员 ID=0 TYPE =22 时，并且该稿件为特约稿件，则自动填充当前用户所在单位
                     * @return {[type]} [description]
                     */
                    scope.autoFillUnit = function() {
                        if (angular.isUndefined(scope.currAuthor.USERNAME) || scope.currAuthor.USERNAME === '') {
                            return;
                        }
                        if (scope.currAuthor.ID == 0 && scope.currAuthor.TYPE === '22' && scope.isSpecial && !scope.currAuthor.COMPANY) {
                            getCurrUserInfo().then(function(data) {
                                scope.currAuthor.COMPANY = data.COMPANY;
                                scope.currAuthor.DEPT = data.DEPT;
                            });
                            scope.tempAuthors[scope.tempAuthors.indexOf(scope.currAuthor)] = scope.currAuthor;
                        }
                    };

                    /**
                     * [getCurrentLoginUser description]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function getCurrentLoginUser() {
                        var deferred = $q.defer();
                        var userParams = {
                            serviceid: 'mlf_extuser',
                            methodname: 'findUserInfo',
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'post').then(function(data) {
                            deferred.resolve(data);
                        });
                        return deferred.promise;
                    }

                    scope.selBank = function() {
                        if (scope.selectedBankOption.value === 0) {
                            delete scope.currAuthor.BANKACCOUNT;
                        } else {
                            scope.currAuthor.BANKACCOUNT = scope.selectedBankOption.name;
                        }
                    };

                    /**
                     * [getCurrUserInfo description]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function getCurrUserInfo() {
                        var deferred = $q.defer();
                        var userParams = {
                            serviceid: 'mlf_extuser',
                            methodname: 'queryGroups',
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'get').then(function(data) {
                            var currAuthorInfo = {};
                            for (var i in data) {
                                if (data[i].GROUPID === scope.status.curGroupId) {
                                    currAuthorInfo = data[i];
                                    var groupPathArr = [];
                                    // var groupPath = data[i].GROUPPATH;
                                    groupPathArr = data[i].GROUPPATH.split('>>');

                                    currAuthorInfo.COMPANY = groupPathArr[0]; // 单位

                                    // groupPathArr.splice(0, 1); //删除数组第一个元素（单位）
                                    groupPathArr.shift(); // 删除数组第一个元素（单位）
                                    groupPathArr.pop(); // 删除数组最后一个元素（空元素）
                                    currAuthorInfo.DEPT = groupPathArr.join('-'); // 部门
                                }
                            }
                            deferred.resolve(currAuthorInfo);
                        });
                        return deferred.promise;
                    }
                },
            };
        },
    ]);
